import React from 'react';
import './Feature.css';

const Feature = () => {
  const features = [
    {
      icon: "flaticon-worker",
      title: "Expert Staffs",
      description: "",
      isDark: true
    },
    {
      icon: "flaticon-building",
      title: "Quality Work",
      description: "",
      isDark: true
    },
    {
      icon: "flaticon-call",
      title: "24/7 Support",
      description: "",
      isDark: true
    }
  ];

  return (
    <div className="feature wow fadeInUp" data-wow-delay="0.1s">
      <div className="container-fluid">
        <div className="row align-items-center">
          {features.map((feature, index) => (
            <div key={index} className="col-lg-4 col-md-12">
              <div className={`feature-item ${feature.isDark ? 'dark-theme' : ''}`}>
                <div className="feature-icon">
                  <i className={feature.icon}></i>
                </div>
                <div className="feature-text">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Feature;